import { cn } from '@/lib/utils';

interface LogoProps {
  /**
   * 'horizontal' — logo con tagline al lado (defecto)
   * 'vertical' — logo apilado
   * 'icon' — solo el isotipo (cuadrado)
   */
  variant?: 'horizontal' | 'vertical' | 'icon';
  className?: string;
  /** Tamaño del logo en altura px (auto-ajusta width) */
  size?: number;
  /**
   * Si true usa la versión optimizada para fondos oscuros. Solo aplica al
   * variant 'horizontal' por ahora — los otros variants no tienen versión
   * dark y caen al asset normal.
   */
  dark?: boolean;
}

const SRC: Record<NonNullable<LogoProps['variant']>, string> = {
  horizontal: '/brand/logo-horizontal.png',
  vertical: '/brand/logo-vertical.png',
  icon: '/brand/icon.png',
};

const SRC_DARK: Partial<Record<NonNullable<LogoProps['variant']>, string>> = {
  horizontal: '/brand/logo-horizontal-dark.png',
};

export function Logo({ variant = 'horizontal', className, size = 40, dark = false }: LogoProps) {
  const src = (dark && SRC_DARK[variant]) || SRC[variant];
  return (
    <img
      src={src}
      alt="Gurumba"
      className={cn('object-contain', className)}
      style={{ height: size, width: 'auto' }}
    />
  );
}
